import 'slick-carousel';
import 'slick-lightbox';

import 'htmx.org';
import AOS from 'aos';
AOS.init( {
    disable: 'mobile',
    once: true,
    duration: 500,
    anchorPlacement: 'top-bottom',
} );

// global
import './global/global.js';
import './global/modal.js';
import './global/header.js';
import './global/footer.js';
import './global/scrollIntoView.js';
import './global/video.js';

import './web-components/dropdown.js';
import './web-components/accordion-item.js';
import './web-components/tabs.js';

/**
 * Template Parts
 */
import './template-parts/accordion.js';
import './template-parts/filters.js';
import './template-parts/single-post.js';
import './template-parts/slider.js';
import './template-parts/dialog.js';

/**
 * Blocks
 */
import "../../blocks/gallery/gallery.js";
import "../../blocks/hero-banner/hero-banner.js";
import "../../blocks/icons/icons.js";
import "../../blocks/staggered-content/staggered-content.js";
import "../../blocks/text-grid/text-grid.js";
